import { NotificationInfo, SysaElement } from './state';
import { Action } from 'redux';

export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const SHOW_NOTIFICATION_INFO = 'SHOW_NOTIFICATION_INFO';
export const REMOVE_NOTIFICATION_INFO = 'REMOVE_NOTIFICATION_INFO';

export type AddNotification = {
    type: typeof ADD_NOTIFICATION;
    payload: SysaElement;
};

export type RemoveNotification = {
    type: typeof REMOVE_NOTIFICATION;
    payload: number;
};

export type ShowNotificationInfo = {
    type: typeof SHOW_NOTIFICATION_INFO;
    payload: NotificationInfo;
};

export type RemoveNotificationInfo = Action<typeof REMOVE_NOTIFICATION_INFO>;

export type NotificationsAction = AddNotification | RemoveNotification | ShowNotificationInfo | RemoveNotificationInfo;
